<template>
  <div class="mt-3" id="board">
    <vue-good-table
      :columns="headings"
      :fixed-header="false"
      :rows="races"
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: false,
        selectionText: 'race(s) selected',
        clearSelectionText: 'clear',
      }"
      :search-options="{
        enabled: true,
        placeholder: 'search...',
      }"
      :pagination-options="{
        enabled: true,
        mode: 'records',
        perPage: 7,
        position: 'bottom',
        dropdownAllowAll: true,
        setCurrentPage: 1,
        nextLabel: 'next',
        prevLabel: 'prev',
        rowsPerPageLabel: 'Races per page',
        ofLabel: 'of',
        allLabel: 'All',
      }"
      :row-style-class="rowStyleClassFn"
      v-on:cell-click="onCellClick"
      styleClass="vgt-table bordered"
      theme="black-rhino"
    >
      <template v-slot:table-row="props">
        <confirm-dialog ref="confirmDialog"></confirm-dialog>
        <!-- race image -->
        <span v-if="props.column.field === 'image'">
          <img
            :src="props.row['image']"
            class="rounded bb-hover"
            height="80"
            width="65"
            alt="race image"
          />
        </span>
        <span v-else>{{ props.formattedRow[props.column.field] }}</span>

        <span v-if="props.column.field === 'special_action_image'">
          <img
            :src="tickImg"
            :class="isVisible(props)"
            height="64"
            width="64"
            alt="special action image"
          />
        </span>

        <span v-if="props.column.field === 'special_reaction_image'">
          <img
            :src="tickImg"
            :class="isVisible(props)"
            height="64"
            width="64"
            alt="special reaction image"
          />
        </span>

        <span v-if="props.column.field === 'character_race_image'">
          <img
            :src="tickImg"
            :class="isVisible(props)"
            height="64"
            width="64"
            alt="character race image"
          />
        </span>

        <span v-if="props.column.field === 'action_delete'">
          <img
            class="bbActionIcon"
            :src="deleteImg"
            @click="confirmDeletion(props.row)"
            height="50"
            width="50"
            alt="delete image"
          />
        </span>
      </template>
      <template #emptystate>No races matching criteria</template>
    </vue-good-table>
  </div>
</template>
  
<script>
import 'vue-good-table-next/dist/vue-good-table-next.css'
import { VueGoodTable } from 'vue-good-table-next'
import ConfirmDialog from './ConfirmDialog.vue'
import { inject } from 'vue'

import deleteImg from '../assets/images/bbDelete48.png'
import tickImg from '../assets/images/bbTick.png'

export default {
  name: 'TableRacesComponent',
  //==================================================================
  // components
  //------------
  components: {
    VueGoodTable,
    ConfirmDialog,
  },
  //==================================================================
  // setup
  //-------
  setup() {
    const global = inject('global')
    return { global }
  },
  //==================================================================
  // props
  //-------
  props: {
    headings: {
      type: Array,
      required: true,
    },
    races: {
      type: Array,
      required: true,
    },
  },
  //==================================================================
  // data
  //------
  data() {
    return {
      selectedValue: null,
      selectedColumn: null,
      selectedRace: null,
      races_array: [],
      deleteImg,
      tickImg,
    }
  },
  //====================================================================
  // methods
  //---------
  methods: {
    //==================================================================
    // is visible
    //------------
    isVisible(props) {
      if (props.column.field == 'special_action_image' && props.row['special_action'] == true) {
        return 'bb-img-visible'
      } else if (
        props.column.field == 'special_reaction_image' &&
        props.row['special_reaction'] == true
      ) {
        return 'bb-img-visible'
      } else if (
        props.column.field == 'character_race_image' &&
        props.row['character_race'] == true
      ) {
        return 'bb-img-visible'
      }
      return 'bb-img-hidden'
    },
    //==================================================================
    // on cell click - open side panel
    //---------------------------------
    onCellClick(props) {
      try {
        if (props.column.field.substring(0, 6) !== 'action') {
          this.emitter.emit('toggle-sidepanel-race', props.row)
        }
      } catch {
        this.emitter.emit('toggle-sidepanel-race', props.row)
      }
    },
    //==================================================================
    // colour rows
    //-------------
    rowStyleClassFn(row) {
      if (row.originalIndex % 2 === 0) {
        return 'rowNeutral'
      } else {
      return 'rowParty'
      }
    },
    //==================================================================
    // confirm deletion
    //------------------
    async confirmDeletion(row) {
      let cmbcnt = row['combatant_count']
      let chrcnt = row['character_count']
      let subject = row['name']
      //
      if (cmbcnt > 0 || chrcnt > 0) {
        subject = subject + '\n'
        if (cmbcnt > 0) {
          subject = subject + '\n' + cmbcnt + ' combatants will be deleted.'
        }
        if (chrcnt > 0) {
          subject = subject + '\n' + chrcnt + ' characters will be deleted.'
        }
      }
      const ok = await this.$refs.confirmDialog.show({
        title: 'Delete Race',
        message: 'Confirm Deletion',
        subject: subject,
        okButton: 'OK',
        cancelButton: 'Cancel',
      })
      if (ok) {
        this.emitter.emit('delete-race', row.originalIndex)
      }
    },
  },
}
</script>